import ApiService from '@/common/api.service'

export default {
  createInvoice (ankenId, payload) {
    return new Promise((resolve, reject) => {
      ApiService.post('/check-list/createOrUpdate/' + ankenId, payload).then(response => {
        resolve(response.data)
      }).catch(error => {
        reject(error)
      })
    })
  },
    getInvoice () {
        return new Promise((resolve, reject) => {
            ApiService.query('/check-list/getList').then(response => {
                resolve(response.data)
            }).catch(error => {
                reject(error)
            })
        })
    },
    getInheritanceByAnkenId (ankenId) {
        return new Promise((resolve, reject) => {
            ApiService.query('/check-list/getList/' + ankenId).then(response => {
                resolve(response.data)
            }).catch(error => {
                reject(error)
            })
        })
    },
    createInvoiceByMember (payload) {
      return new Promise((resolve, reject) => {
        ApiService.post('/check-list/createOrUpdate', payload).then(response => {
          resolve(response.data)
        }).catch(error => {
          reject(error)
        })
      })
    }
}
